/**
 * Header Facade Service
 * Combines notification and user services for header component
 */

import { Injectable, inject, computed } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationService } from './notification.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderFacadeService {
  private readonly notificationService = inject(NotificationService);
  private readonly userService = inject(UserService);

  readonly notifications = this.notificationService.notifications;
  readonly unreadCount = this.notificationService.unreadCount;
  readonly user = this.userService.user;

  readonly userInitial = computed(() => this.userService.getUserInitial());
  readonly userName = computed(() => this.userService.getUserName());

  loadNotifications(): Observable<any> {
    return this.notificationService.loadNotifications();
  }

  markNotificationAsRead(id: number): void {
    this.notificationService.markAsRead(id);
  }

  markAllAsRead(): void {
    this.notificationService.markAllAsRead();
  }

  deleteNotification(id: number): void {
    this.notificationService.deleteNotification(id);
  }

  togglePin(id: number): void {
    this.notificationService.togglePin(id);
  }

  archiveNotification(id: number): void {
    this.notificationService.archiveNotification(id);
  }

  clearNotifications(): void {
    this.notificationService.clearAll();
  }

  searchNotifications(query: string): void {
    this.notificationService.search(query);
  }

  isAdmin(): boolean {
    return this.userService.isAdmin();
  }

  getUserProfile() {
    return this.userService.getUserProfile();
  }

  updatePreferences(preferences: any): void {
    this.userService.updatePreferences(preferences);
  }
}

